/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
console.log(
	'Hello World! (from create-block-automateit-cmms-roi-calculator block)'
);
/* eslint-enable no-console */

Fancybox.bind("[data-fancybox]", {});

function formatCurrency(value) {
	return value.toLocaleString('en-US', {
	  style: 'currency',
	  currency: 'USD',
	  minimumFractionDigits: 2,
	  maximumFractionDigits: 2
	}).replace(/\$/g, '');
  }

  function calculateServiceFee(licenseCount) {
	if (licenseCount <= 25) {
	  return 30000;
	} else if (licenseCount >= 26 && licenseCount <= 75) {
	  return 50000;
	} else if (licenseCount >= 76 && licenseCount <= 200) {
	  return 80000;
	} else if (licenseCount >= 201) {
	  return 100000;
	}
  }
  
function computeYearly(initialOutput, annualFee, initialFee, decayRate, discountRate, maxIterations) {
	
	let year = 1;
	let savings = initialOutput;
	let fee = annualFee + initialFee;
	let netSavings = savings - fee;

	

	let discountFactor = Math.pow(1 + discountRate, year);
	let presentValue = (netSavings / discountFactor);

	let results = [ { savings, fee , netSavings, presentValue }];

	fee = annualFee;

	for (let i = 0; i < (maxIterations - 1) ; i++) {

		const marginalOutput = savings * (1 - decayRate);
		savings = marginalOutput;
		
		fee = ( fee * 1.05 );
		
		netSavings = ( savings - fee );

		year++;;

		let discountFactor = Math.pow(1 + discountRate, year);
		
		presentValue = (netSavings / discountFactor);
		
		results.push({ savings, fee, netSavings, presentValue });

	}

	return results;

  }

  function computeTotal(data) {
	let result = []
	let npv = 0;
	let netSavings = 0;
	let cost = 0;
	for (let i = 0; i < data.length; i++) {
		//console.log(data[i].presentValue );
		npv +=  data[i].presentValue;
		netSavings +=  data[i].netSavings;
		cost +=  data[i].fee;
	}

	const roi = ((netSavings - cost) / cost) * 100;

	result = [ { npv , roi }]
	return result;
  }


function doCalculate() {

	let timePeriod = 4;

	const decayRateInput = document.getElementById('decayRate');
	let decayRate = parseFloat(decayRateInput.innerHTML) / 100;

	const discountRateInput = document.getElementById('discountRate');
	let discountRate = parseFloat(discountRateInput.innerHTML) / 100;

	// ========================================

	const licenseInvestmentInput = document.getElementById('licenseInvestment');
	let licenseInvestment = parseFloat(licenseInvestmentInput.value);
	let softwareInvestment = ( licenseInvestment * 110 ) * 12;
	let serviceInvestment = calculateServiceFee( licenseInvestment );
	let totalInvestment = softwareInvestment + serviceInvestment;
	document.getElementById('softwareInvestment').innerHTML = `$ ${formatCurrency(softwareInvestment)}`;
	document.getElementById('serviceInvestment').innerHTML = `$ ${formatCurrency(serviceInvestment)}`;
	document.getElementById('totalInvestment').innerHTML = `$ ${formatCurrency(totalInvestment)}`;

	// ========================================

	const laborValueInput = document.getElementById('laborValue');
	const laborGainInput = document.getElementById('laborGain');
	let laborValue = parseFloat(laborValueInput.value);
	let laborGainPercentage = parseFloat(laborGainInput.value) / 100;
	let laborCostSaving =  laborValue * laborGainPercentage ;
	document.getElementById('laborCostSaving').innerHTML = `$ ${formatCurrency(laborCostSaving)}`;

	// ========================================

	const inventoryBaseCostInput = document.getElementById('inventoryBaseCost');
	const inventorySavingsInput = document.getElementById('inventorySavings');
	let inventoryBaseCost = parseFloat(inventoryBaseCostInput.value);
	let inventorySavings = parseFloat(inventorySavingsInput.value) / 100;
	let inventoryCostSavings =   inventoryBaseCost * inventorySavings;
	document.getElementById('inventoryCostSavings').innerHTML = `$ ${formatCurrency(inventoryCostSavings)}`;

	// ========================================

	const unplannedDowntimeAverageInput = document.getElementById('unplannedDowntimeAverage');
	const productionRateInput = document.getElementById('productionRate');
	const grossProfitUnitInput = document.getElementById('grossProfitUnit');
	const downtimeSavingsInput = document.getElementById('downtimeSavings');

	let unplannedDowntimeAverage = parseFloat(unplannedDowntimeAverageInput.value);
	let productionRate = parseFloat(productionRateInput.value);
	let grossProfitUnit = parseFloat(grossProfitUnitInput.value);
	let downtimeSavings = parseFloat(downtimeSavingsInput.value) / 100;

	const downtimeReductionSavings = ( unplannedDowntimeAverage * productionRate * grossProfitUnit) * downtimeSavings;

	document.getElementById('downtimeReductionSavings').innerHTML = `$ ${formatCurrency(downtimeReductionSavings)}`;
	let initialSavings = laborCostSaving + inventoryCostSavings + downtimeReductionSavings;
	document.getElementById('initialSavings').innerHTML = `$ ${formatCurrency(initialSavings)}`;


	// ========================================

	const yearlySavings = computeYearly(initialSavings, softwareInvestment, serviceInvestment, decayRate, discountRate, timePeriod );
	console.log (yearlySavings);
// ========================================

	const yearlySavingsDiv = document.getElementById("yearlySavings");
	yearlySavingsDiv.innerHTML = '<td><b>Yearly Savings with Diminishing Returns</b> <button data-fancybox data-src="#dialog-diminishing-return" class="definition"></button></td>';
	
	const yearlySoftwareInvestmentDiv = document.getElementById("yearlySoftwareInvestment");
	yearlySoftwareInvestmentDiv.innerHTML = '<td><b>Yearly Software Investment</b></td>';

	const yearlyNetSavingsDiv = document.getElementById("yearlyNetSavings");
	yearlyNetSavingsDiv.innerHTML = '<td><b>Yearly Net Savings</b></td>';

	const yearlyPresentValueDiv = document.getElementById("yearlyPresentValue");
	yearlyPresentValueDiv.innerHTML = '<td><b>Yearly Net Present Value</b></td>';


	//let totalSavings = 0;
	for (let i = 0; i < yearlySavings.length; i++) {
		yearlySavingsDiv.innerHTML += `<td align="right">$ ${formatCurrency(yearlySavings[i].savings)} </td>`;
		yearlySoftwareInvestmentDiv.innerHTML += `<td align="right">$ ${formatCurrency( yearlySavings[i].fee )} </td>`;
		yearlyNetSavingsDiv.innerHTML += `<td align="right">$ ${formatCurrency( yearlySavings[i].netSavings )} </td>`;
		yearlyPresentValueDiv.innerHTML += `<td align="right">$ ${formatCurrency( yearlySavings[i].presentValue )} </td>`;
	
		// totalSavings += yearlySavings[i].output;
	}



	// ========================================

	const result = computeTotal(yearlySavings);

	console.log( result );

	const npvDiv = document.getElementById("npv");
	npvDiv.innerHTML = `$ ${formatCurrency( result[0].npv )} `;
	
	const roiDiv = document.getElementById("roi");
	roiDiv.innerHTML = ` ${ result[0].roi.toFixed(2)  } %`;
}


document.addEventListener('input', function(event) {
	if (event.target.tagName === 'INPUT') {
	  // do something when any input field changes
	  doCalculate();
	}
  });

  doCalculate();

  const inputFields = document.querySelectorAll('.input-limit');

inputFields.forEach((inputField) => {
  inputField.addEventListener('input', (e) => {
    const inputValue = parseInt(e.target.value);
    const minAllowed = parseInt(inputField.getAttribute('data-min'));
    const maxAllowed = parseInt(inputField.getAttribute('data-max'));

    if (inputValue < minAllowed || inputValue > maxAllowed) {
		inputField.closest('.input-group').classList.add('invalid-input');
      	const errorMessage = `Please enter a value between ${minAllowed} and ${maxAllowed}`;
      	inputField.closest('.input-group ').nextElementSibling.innerHTML = errorMessage;
	

    } else {
		inputField.closest('.input-group').classList.remove('invalid-input');
      	inputField.closest('.input-group').nextElementSibling.innerHTML = '';
    }
  });
});